import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL } from '@app-shared/constants/service-urls';
import { ApiService } from '@app-shared/services/api.service';
import { APIRequest } from '@app-shared/services/req-res.types';
import { UtilService } from '@app-shared/services/util.service';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private operationsDataRequests = new Map<string, any>();

  clearCache() {
    this.operationsDataRequests.clear();
  }
  constructor(
    private api: ApiService,
    private util: UtilService,
    private http: HttpClient
  ) {}

  getRevisionHistory(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.REVISON_HISTORY, postData );
  }

  getResourcesData(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.RESOURCES_DATA, postData );
  }

  getOperationsData(data: any, forceRefresh = false) {
    const key = `${data.org_id}_${data.start_date}_${data.end_date}`;
    if (forceRefresh) {
      this.operationsDataRequests.delete(key);
    }
    if (this.operationsDataRequests.has(key)) {
      return this.operationsDataRequests.get(key);
    }

    const postData: APIRequest = {
      requestBody: {
        ...data,
      }
    };
    const request = this.api.post(URL.ADMIN.OPERATIONS_DATA, postData ).pipe(
      map((response: any) => {
        const responseBody = response['body']?.['responseBody'] || response?.['responseBody'] || response;
        if (responseBody && responseBody.operationsData) {
          const opsData = responseBody.operationsData;
          if (!opsData.pass_fail && opsData.candidate_data_by_performance) {
            const assessment_wise = opsData.candidate_data_by_performance.map((item: any) => {
              let reassessed_count = 0;
              if (opsData.reassessment_stats) {
                const rMatch = opsData.reassessment_stats.find((r: any) => 
                  r.course_name && r.course_name.trim().toLowerCase() === item.course_name.trim().toLowerCase()
                );
                if (rMatch) {
                  reassessed_count = rMatch.reassessed_count || 0;
                }
              }
              const stateName = item.assessment_state || item.state || 'Unknown';
              const state_pass_counts = {};
              const state_fail_counts = {};
              const state_reassessed_counts = {};
              
              state_pass_counts[stateName] = item.pass_count || 0;
              state_fail_counts[stateName] = item.fail_count || 0;
              state_reassessed_counts[stateName] = reassessed_count;

              return {
                assessment_id: item.assessment_id,
                assessment_name: item.assessment_name,
                assessment_title: item.assessment_name,
                course_id: item.course_id || item.assessment_id,
                course_name: item.course_name,
                pass_count: item.pass_count || 0,
                fail_count: item.fail_count || 0,
                reassessed_count: reassessed_count,
                candidate_count: item.candidate_count || 0,
                language: item.language || item.language_name || '',
                state: stateName,
                state_pass_counts: state_pass_counts,
                state_fail_counts: state_fail_counts,
                state_reassessed_counts: state_reassessed_counts
              };
            });

            const totalPass = assessment_wise.reduce((sum, item) => sum + item.pass_count, 0);
            const totalFail = assessment_wise.reduce((sum, item) => sum + item.fail_count, 0);
            const totalCandidates = totalPass + totalFail;

            opsData.pass_fail = {
              overall_pass_percent: totalCandidates > 0 ? (totalPass / totalCandidates) * 100 : 0,
              overall_fail_percent: totalCandidates > 0 ? (totalFail / totalCandidates) * 100 : 0,
              assessment_wise: assessment_wise
            };
          }
        }
        return response;
      }),
      shareReplay(1)
    );

    this.operationsDataRequests.set(key, request);
    return request;
  }

  getGeography(data: any = {}) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.GEOGRAPHY_DATA, postData );
  }

  getCoursesMasterData(data: any = {}) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.COURSES_MASTER, postData );
  }

  getLanguagesMasterData(data: any = {}) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.LANGUAGES_MASTER, postData );
  }

  getSalesCustomerMasterData(data: any = {}) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.CUSTOMERS_MASTER, postData );
  }

  getSalesData(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.SALES_DATA, postData );
  }
  getContentsData(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.CONTENTS_DATA, postData );
  }
  getFinancesData(data: any) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.FINANCES_DATA, postData );
  }

  getConsolidatedDashboardData(data: any) {
    const postData: APIRequest = {
      requestBody: {
        ...data,
      }
    };
    return this.api.post(URL.ADMIN.CONSOLIDATED_DASHBOARD_DATA || '/getConsolidatedDashboardData', postData);
  }

  getAllProduct(data: any = {}) {
    const postData: APIRequest = {
              requestBody: {
                ...data,
              }
            };
    return this.api.post(URL.ADMIN.GET_ALL_PRODUCT, postData );
  }

}
